import { render, staticRenderFns } from "./header-view.vue?vue&type=template&id=4a9f7e64&"
import script from "./header-view.vue?vue&type=script&lang=js&"
export * from "./header-view.vue?vue&type=script&lang=js&"
import style0 from "./header-view.vue?vue&type=style&index=0&id=4a9f7e64&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports